import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import { AuthProvider } from "./store/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

// Pages
import LoginPage from "./pages/auth/LoginPage";
import VerifyPage from "./pages/auth/VerifyPage";
import BusinessesPage from "./pages/businesses/BusinessesPage";
import UsageListPage from "./pages/usage/UsageListPage";
import CreateUsagePage from "./pages/usage/CreateUsagePage";
import EditUsagePage from "./pages/usage/EditUsagePage";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/login" element={<LoginPage />} />
            <Route path="/verify" element={<VerifyPage />} />

            {/* Protected */}
            <Route path="/businesses" element={
              <ProtectedRoute><BusinessesPage /></ProtectedRoute>
            } />
            <Route path="/businesses/:businessid/usage" element={
              <ProtectedRoute><UsageListPage /></ProtectedRoute>
            } />
            <Route path="/businesses/:businessid/usage/create" element={
              <ProtectedRoute><CreateUsagePage /></ProtectedRoute>
            } />
            <Route path="/businesses/:businessid/usage/:usageid/edit" element={
              <ProtectedRoute><EditUsagePage /></ProtectedRoute>
            } />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
